import React, { useState, useEffect } from "react";
import { Redirect, Route, Link, useParams, useLocation, useHistory } from "react-router-dom";

import Faqs from "../components/Faqs";
import Swal from "sweetalert2";

//New structure

import GameSlider from "elements/gameElements/GameSlider";
import CategoryGameContainer from "elements/gameElements/CategoryGameContainer";
import Winners from "../components/Winners";
import HomeBanner from "elements/HomeBanner";
// import StepRightUp from "elements/home/StepRightUp";
// import BringOn from "elements/home/BringOn";
import GameMenu from "elements/gameElements/GameMenu";
import HomeFullBanner from "elements/HomeFullBanner";
import FeatureItems from "elements/home/FeatureItems";
import SeoContent from "components/SeoContent";

export default function Landing(props) {
  const [seconds, setSeconds] = useState(4083958);
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 60);
    return () => clearInterval(interval);
  }, []);

  const [categoryName, setCategoryName] = useState("All Games");
  const __ = (text) => text;

  // Deposit return banner. Redirect-based PSPs (La Mecanica, Rillpay, PayPal)
  // send the player back to /payment-status/<status>. PayPal uses the legacy
  // true/false values; the canonical PaymentReturnUrl helper uses
  // success/failed/cancelled. One brand-neutral, English banner covers all.
  // Note: on "success" the actual crediting is confirmed asynchronously via the
  // provider webhook, so we never claim the balance is already updated.
  useEffect(() => {
    const status = (params.status || "").toLowerCase();
    if (!status) return;

    const successStates = ["true", "success", "approved", "captured"];
    const failureStates = ["false", "failed", "error", "declined"];
    const cancelStates = ["cancelled", "canceled"];

    const darkTheme = {
      background: "#2e2e2e", // Dark background color
      color: "#fff", // White text color
      customClass: {
        popup: "dark-theme-popup",
        title: "dark-theme-title",
        content: "dark-theme-content",
      },
    };

    const txId = new URLSearchParams(location.search).get("transactionId");
    const ref = txId ? ` (Ref: ${txId})` : "";

    if (successStates.includes(status)) {
      Swal.fire({
        ...darkTheme,
        title: "Payment received",
        text: `Thank you, your deposit has been received. Your balance will update shortly.${ref}`,
        icon: "success",
      });
    } else if (cancelStates.includes(status)) {
      Swal.fire({
        ...darkTheme,
        title: "Payment cancelled",
        text: `No funds were charged.${ref}`,
        icon: "info",
      });
    } else if (failureStates.includes(status)) {
      Swal.fire({
        ...darkTheme,
        title: "Payment failed",
        text: `Your payment could not be completed. Please try again or use another method.${ref}`,
        icon: "error",
      });
    }
  }, [params.status, location.search]);

  return (
    <>
      <div className="container-xxl">
        {/* <Banner {...props} /> */}
        <HomeFullBanner callFrom={"home"} {...props} />

        {/* <div className="gameHeading">{__("Sweeplay Games")}</div> */}
        {/* <GameSlider
          categoryName="Popular"
          category="video_slots"
          perPage="20"
          {...props}
        /> */}
        <FeatureItems {...props} />
        {<GameMenu callFromSlider={false} {...props} />}

        <CategoryGameContainer {...props} />
        <Winners {...props} />


        <GameSlider
          {...props}
          categoryName="New"
          menuBar={false}
          category="new"
          perPage="20"
          title={true}
        />

        <GameSlider
          {...props}
          categoryName="Table Games"
          menuBar={false}
          category="table_games"
          perPage="20"
          title={true}
        />


        {/* <StepRightUp {...props} /> */}

        {/* <Faqs heading={true} {...props} /> */}
        {/* <BringOn {...props} /> */}

        <div className="singleItemBanner">
          <div className="singleItemBanner__inner">
            <div className="singleItemBanner__visual">
              <img
                alt="Dice and playing cards"
                className="bannerImg"
                src={require("../assets/play365/images/banners/roll-the-disk-banner.webp")}
              />
            </div>
            <div className="bannercontent">
              <h3 className="headingText">Roll the Dice, Chase the Prize!</h3>
              <p>
                Feel the rush as cards flip and chips stack up in this high-stakes
                casino adventure. Test your luck and go for the big win!
              </p>
              <button
                type="button"
                onClick={() => {
                  if (!props.isAuthenticated) {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  } else {
                    history.push("/games/all");
                  }
                }}
                className="commonBtn pOneBtn"
              >
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_318_14432)">
                    <path
                      d="M13.8232 0.456055C6.64353 0.456055 0.823242 6.27635 0.823242 13.4561C0.823242 20.6358 6.64353 26.4561 13.8232 26.4561C21.003 26.4561 26.8232 20.6358 26.8232 13.4561C26.8232 6.27635 21.003 0.456055 13.8232 0.456055ZM10.2712 19.1103V7.80182L20.0646 13.4561L10.2712 19.1103Z"
                      fill="#05070B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_318_14432">
                      <rect
                        width="26"
                        height="26"
                        fill="white"
                        transform="translate(0.823242 0.456055)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <span>{__("Play Now!")}</span>
              </button>
            </div>
          </div>
        </div>

        <Faqs heading={true} {...props} />
        <br />
        <br />
        <br />
        {/* <BringOn {...props} /> */}
        <SeoContent {...props} />
      </div>
    </>
  );
}
